import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Sessions } from 'src/app/libraries/sessions';
import { IReturn } from 'src/app/libraries/ireturn';
import { APP_BASE_HREF } from '@angular/common';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ServiciosTiposService {

  constructor(private http: HttpClient,  @Inject(APP_BASE_HREF) private baseUrl: string) { }

  dataSource(varArgs : any = null): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Servicios/Tipos/DataSource", varArgs, Sessions.header());
  }

  store(objServicioTipo : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Servicios/Tipos/Store", objServicioTipo, Sessions.header());
  }

  update(objServicioTipo : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Servicios/Tipos/Update", objServicioTipo, Sessions.header());
  }

  delete(objServicioTipo : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Servicios/Tipos/Delete", objServicioTipo, Sessions.header());
  }

}